import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Shop from "./Pages/Shop";
import Cart from "./Pages/Cart";
import Footer from "./Components/Footer/Footer";
import ShopCategory from "./Pages/ShopCategory";
import LoginSignup from "./Pages/LoginSignup";
import MyOrders from "./Pages/MyOrders";
import Profile from './Pages/Profile';
import Terms from './Pages/Terms';
import Privacy from './Pages/Privacy';
import Returns from './Pages/Returns';
import Shipping from './Pages/Shipping.jsx';
import ContactUs from './Pages/ContactUs.jsx';
import Address from './Pages/Address';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// --- UI/UX UPGRADE: Create a layout component to access router hooks ---
const AppLayout = () => {
  const location = useLocation();
  // We will hide the footer on the cart page to avoid clashing with the floating bar
  const showFooter = location.pathname !== '/cart';

  return (
    <>
      <Navbar />
      <ToastContainer
        position="bottom-center" // Better for mobile visibility
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/" element={<Shop />} />
        <Route path="/combos" element={<ShopCategory banner="/images/madurai-combos-banner-new.png" category="Combo" />} />
        <Route path="/myorders" element={<MyOrders />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<LoginSignup />} />
        <Route path='/profile' element={<Profile />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/Shipping" element={<Shipping />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/address" element={<Address />} />
      </Routes>
      {showFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <div>
      <Router>
        {/* The AppLayout component contains all the main content */}
        <AppLayout />
      </Router>
    </div>
  );
}

export default App;